import {RootState} from '@src/store/store'
import {OrdersStateType} from '@src/store/ducks/orders/reducer'


export const selectOrders = (state: RootState): OrdersStateType => state.orders

export const selectOrdersPassengersQuantity = (state: RootState) => selectOrders(state).passengersQuantity
export const selectOrdersisPreorder = (state: RootState) => selectOrders(state).isPreorder
export const selectCurrentChoosenTourData = (state: RootState) => selectOrders(state).currentChoosenTourData
export const selectCurrentChoosenTourDataHotels = (state: RootState) => selectOrders(state).currentChoosenTourData.hotels

export const selectCurrentChoosenTourDataPaymentType = (state: RootState) => selectOrders(state).currentChoosenTourData.paymentType

export const selectCityTour = (state: RootState) => selectOrders(state).currentChoosenTourData.parsedRoutes

export const selectCurrentBusPlaces = (state: RootState) => selectOrders(state).currentBusPlaces
export const selectCurrentChoosenBusPlaces = (state: RootState) => selectOrders(state).currentChoosenBusPlaces

export const selectRoomTypes = (state: RootState) => selectOrders(state).ordersParams.roomTypes
export const selectCitizenCategory = (state: RootState) => selectOrders(state).ordersParams.citizenCategory
export const selectGender = (state: RootState) => selectOrders(state).ordersParams.gender

export const selectOrderStatuses = (state: RootState) => selectOrders(state).ordersParams.orderStatuses
export const selectSourceRegirstration = (state: RootState) => selectOrders(state).ordersParams.sourceRegirstration

export const selectCurrentFreePlaces = (state: RootState) => selectOrders(state).currentChoosenTourData.freePlaces
export const selectCurrentFreePlacesEmployee = (state: RootState) => selectOrders(state).currentChoosenTourData.placesInfo?.freePlacesForEmployee
export const selectCurrentFreePlacesPartner = (state: RootState) => selectOrders(state).currentChoosenTourData.placesInfo?.freePlacesForPartner

export const selectSteps = (state: RootState) => selectOrders(state).stepsState

export const selectHistoryOrdersDate = (state: RootState) => selectOrders(state).historyData.orders?.data

export const selectOrderId = (state: RootState) => selectOrders(state).orderId

export const selectOrdersHistoryNextPage = (state: RootState) => selectOrders(state).historyData.nextPage
